export const TemplateConstants = {
  WebApiHost:      'https://template-api-local.servicecatalog.aws.boisestate.edu/',
  UserRole:        'All-Students',
  AdminRole:       'All-Employees',
  PathPrefix:      '/template',
  AdminPathPrefix: '/template/admin',
  AdminHashPrefix: '/#/template/admin',
  UserPathPrefix:  '/template/user',
  UserHashPrefix:  '/#/template/user',
};